import { render, staticRenderFns } from "./VaMessageList.demo.vue?vue&type=template&id=4a2b81ed&"
import script from "./VaMessageList.demo.vue?vue&type=script&lang=js&"
export * from "./VaMessageList.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports